module.exports = __webpack_public_path__ + "img/scene-2.921f5a8.png";